module.exports = __webpack_public_path__ + "static/media/Bear978_2c.f009db2d.svg";